import PropTypes from "prop-types";
import { Field } from "redux-form";

import { HOLD_RETURNS } from "../../constants/strings";
import { HOLD_RETURNS_FIELD } from "../../features/userDetailsForm/returnSettings/returnSettings.constants";
import CustomSwitchWithTitle from "../SwitchWidthTitle/CustomSwitchWithTitle";

const HoldReturns = ({ onInputChange }) => (
  <Field
    name={HOLD_RETURNS_FIELD}
    component={CustomSwitchWithTitle}
    type="checkbox"
    label={HOLD_RETURNS}
    onChange={(event, value) => {
      onInputChange(HOLD_RETURNS_FIELD, value);
    }}
  />
);

HoldReturns.defaultProps = {
  onInputChange: () => null,
};

HoldReturns.propTypes = {
  onInputChange: PropTypes.func.isRequired,
};

export default HoldReturns;
